import React from 'react';
import PropTypes from 'prop-types';
import intransfer from '@/js/intransfer';
import Modal from '@/js/components/common/Modal';

const NoCategoriesModal = (props) => {
	let footerFragment = (
		<React.Fragment>
			<button type="button" className="btn btn-primary"
				onClick={() => {
					gtag('event', 'go_to_internal', {
						page: 'categories'
					});
					intransfer.compass.toCategories(props.meetingId);
				}}
			>
				Go to Categories
			</button>
		</React.Fragment>
	);

	return (
		<Modal header={`Categories must be created before ${props.titleAction}`} footer={footerFragment}>
			This event does not have any categories to {props.bodyAction} to. Categories must be created in order to use this tool.
		</Modal>
	);
};

NoCategoriesModal.propTypes = {
	meetingId: PropTypes.number.isRequired,
	titleAction: PropTypes.string.isRequired,
	bodyAction: PropTypes.string.isRequired
};

export default NoCategoriesModal;
